const labelGenerator = (label, isCustom, scope) => {
  let formattedLabel = label
    .replace(/([A-Z])/g, ' $1')
    .replace(/_/g, ' ')
    .trim()
    .toLowerCase()
    .split(' ')
    .map((ss) => ss.split('.'))
    .flat()
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  if (isCustom) {
    formattedLabel = `${formattedLabel} (${scope} custom field)`;
  }

  return formattedLabel;
};
export default labelGenerator;
